import React, { useEffect } from "react";
import styles from "./OneFormation.module.scss";
import { useParams } from "react-router-dom";

import { formations as fake_data } from "../../../assets/data/Formations";
import LeftColoredTitle from "../../../components/Titles/LeftColoredTitle";

function OneFormation() {
  const { id } = useParams();
  const [formation, setFormation] = React.useState(null);
  useEffect(() => {
    let fake_format = fake_data.find((formation) => formation._id === id);
    setFormation(fake_format);
  }, [id]);
  return formation ? (
    <div className={styles.main}>
      <LeftColoredTitle>{formation.title}</LeftColoredTitle>
      <HeadXagonal />

      <p className={styles.description}>
        L'Université Ibn Khaldoun compte aujourd'hui plus de 7000 diplômés issus
        de plus de trente nationalités différentes, qui ont poursuivi leur
        carrière dans divers domaines à travers le monde. L'association Alumni
        de l'UIK joue un rôle crucial en offrant un réseau professionnel visant
        à faciliter l'insertion et la mobilité professionnelle des anciens
        diplômés de l'université. UIK Alumni Network est une ressource
        essentielle pour les anciens étudiants de l'Université Ibn Khaldoun.
        Elle favorise le réseautage, le mentorat et l'accès à des opportunités
        professionnelles. Les anciens étudiants ont la possibilité de rester en
        contact avec leur alma mater grâce à cette association. De plus, elle
        propose des programmes de formation continue et des ateliers visant le
        développement professionnel. Par ailleurs, UIK Alumni Network offre un
        soutien précieux dans la recherche d'emploi et l'évolution de carrière
        grâce à son vaste réseau d'entreprises partenaires. Elle permet aux
        anciens étudiants de bénéficier du réseau et de l'expertise de
        professionnels chevronnés.
      </p>
    </div>
  ) : null;
}

const HeadXagonal = () => {
  return (
    <div className={styles.hexagonals_container}>
      <div className={styles.hexagonals}>
        <Hexagonal>
          <h2>Durée</h2>
          <p>
            Temps Partiel : <strong> 6 mois </strong>
          </p>
          <ul>
            <li>Cours du soir</li>
            <li>Cours pendant le weekend</li>
          </ul>
        </Hexagonal>
        <Hexagonal>
          <h2>Public cible</h2>
          <p>Moyens et Hauts Cadres:</p>
          <ul>
            <li>Licence</li>
            <li>Master</li>
            <li>Ingénieur</li>
            <li>Doctorat ou équivalent</li>
          </ul>
        </Hexagonal>
        <Hexagonal>
          <h2>Prix</h2>
          <div className={styles.centerer}>
            <div className={styles.centerer_content}>
              <p>
                6500 <strong> DT </strong>
              </p>
            </div>
          </div>
        </Hexagonal>
      </div>
    </div>
  );
};

const Hexagonal = ({ children }) => {
  return (
    <div className={styles.hexagonal}>
      <div className={styles.inside}>{children}</div>
    </div>
  );
};

export default OneFormation;
